import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Instructor } from '../models/instructor.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstructorService {
  private apiUrl = `${environment.apiUrl}/instructores`;

  constructor(private http: HttpClient) {}

  getInstructores(): Observable<Instructor[]> {
    return this.http.get<Instructor[]>(this.apiUrl);
  }

  getInstructor(id: number): Observable<Instructor> {
    return this.http.get<Instructor>(`${this.apiUrl}/${id}`);
  }

  addInstructor(instructor: Instructor): Observable<Instructor> {
    return this.http.post<Instructor>(`${this.apiUrl}/registro`, instructor);
  }

  updateInstructor(instructor: Instructor): Observable<Instructor> {
    return this.http.put<Instructor>(`${this.apiUrl}/${instructor.id}/updt`, instructor);
  }

  getUltimoExamen(nroLibreta: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/estudiantes/${nroLibreta}/examen`);
  }

  getGraduacion(nroLibreta: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/estudiantes/${nroLibreta}/graduacion`);
  }

  getEmail(nroLibreta: number): Observable<{ email: string }> {
    return this.http.get<{ email: string }>(`${environment.apiUrl}/estudiantes/${nroLibreta}/email`);
  }
}
